import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Плакаты на плотной матовой бумаге.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
